module.exports = __webpack_public_path__ + "img/xcontract_position_img.161b0d77.png";